import * as Yup from 'yup'

export const formulaSchema = Yup.object().shape({
  formula: Yup.string().trim().required('É necessário o nome do fórmula'),
  descricao: Yup.string().trim().required('É necessária a composição da fórmula'),
})
